export default __webpack_public_path__ + "img/favicon.asset.0e5cb661.png";